// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Aggs","option":"styles_option__1sViw","selected":"styles_selected__18xCi"};